import { createContext } from 'react';
import type { Session } from '../net/session';

export const SessionContext = createContext<Session | null>(null);
